import React from 'react';
import {
    Box,
    Button,
    Badge,
    FormControl,
    FormLabel,
    Input,
    Flex,
    SimpleGrid,
    IconButton,
    Tooltip,
    Heading,
    Text,
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

const Step3AdvancedOptions = ({ options, setOptions }) => {

    const handleColorChange = (optionIndex, colorIndex, field, value) => {
        const newOptions = [...options];
        newOptions[optionIndex].colors[colorIndex][field] = value;
        setOptions(newOptions);
    };

    const addColor = optionIndex => {
        const newOptions = [...options]
        if (!Array.isArray(newOptions[optionIndex].colors)) {
            newOptions[optionIndex].colors = []
        }
        newOptions[optionIndex].colors.push({ color: '', woocommerce_product_id: '' })
        setOptions(newOptions)
    }

    const removeColor = (optionIndex, colorIndex) => {
        const newOptions = [...options];
        newOptions[optionIndex].colors = newOptions[optionIndex].colors.filter((_, i) => i !== colorIndex);
        setOptions(newOptions);
    };

    return (
        <Box>
            {options.map((option, optionIndex) => (
                <Box key={optionIndex} mb="6" p={{ base: 4, md: 5 }} borderWidth="1px" borderRadius="2xl" boxShadow="sm" bg="white">
                    <Flex justify="space-between" align={{ base: 'flex-start', md: 'center' }} gap="4" mb="5" direction={{ base: 'column', md: 'row' }}>
                        <Box>
                            <Badge colorScheme="purple" borderRadius="full" mb="2">
                                Option {optionIndex + 1}
                            </Badge>
                            <Heading as="h4" size="sm">
                                {option.name || `Option ${optionIndex + 1}`}
                            </Heading>
                            <Text fontSize="sm" color="gray.500" mt="1">
                                Add color variants and the WooCommerce product ID attached to each color.
                            </Text>
                        </Box>
                        <Button colorScheme="blue" onClick={() => addColor(optionIndex)} width={{ base: 'full', md: 'auto' }}>
                            Add Color
                        </Button>
                    </Flex>

                    {!option.colors?.length && (
                        <Box p="4" bg="gray.50" borderRadius="xl" mb="4">
                            <Text fontSize="sm" color="gray.500">
                                No colors added for this option yet.
                            </Text>
                        </Box>
                    )}

                    {option.colors?.map((color, colorIndex) => (
                        <SimpleGrid
                            columns={{ base: 1 }}
                            templateColumns={{ md: 'minmax(0, 1fr) minmax(0, 1fr) auto' }}
                            spacing="4"
                            mb="4"
                            key={`${optionIndex}-${colorIndex}`}
                            alignItems="end"
                        >
                            <FormControl>
                                <FormLabel>Color</FormLabel>
                                <Input
                                    value={color.color}
                                    onChange={(e) => handleColorChange(optionIndex, colorIndex, 'color', e.target.value)}
                                    w="100%"
                                    placeholder="e.g. Black"
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>WooCommerce Product ID</FormLabel>
                                <Input
                                    value={color.woocommerce_product_id}
                                    onChange={(e) => handleColorChange(optionIndex, colorIndex, 'woocommerce_product_id', e.target.value)}
                                    w="100%"
                                    placeholder="WooCommerce product ID"
                                />
                            </FormControl>
                            <Flex alignItems="end" justifyContent={{ base: 'flex-start', md: 'center' }}>
                                <Tooltip label="Delete Color">
                                    <IconButton
                                        icon={<DeleteIcon />}
                                        onClick={() => removeColor(optionIndex, colorIndex)}
                                        colorScheme="red"
                                        size="sm"
                                    />
                                </Tooltip>
                            </Flex>
                        </SimpleGrid>
                    ))}
                </Box>
            ))}
        </Box>
    );
};

export default Step3AdvancedOptions;
